import { cn } from '@/utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';

const badgeVariants = cva(
  'inline-flex items-center rounded border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-typography shadow',
        secondary: 'border-transparent bg-secondary text-typography-900',
        destructive: 'border-transparent bg-error-400 text-typography shadow',
        outline: 'text-typography-900',
        new: 'border-transparent bg-primary-800 text-typography shadow',
        dot: 'size-2 rounded-full border-transparent bg-primary-800 p-0'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = ({
  className,
  variant,
  ...props
}: BadgeProps & {
  ref?: React.RefObject<HTMLDivElement>;
}) => {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
};

export { Badge, badgeVariants };
